import { apiGet, unwrapData } from './helpers'

/**
 * @param {string} lanePath - `weightloss/reports` | `insurance/weightloss/reports`
 */
export function createReportsApi(lanePath) {
  return {
    /**
     * Pacientes enrolados por OMA (solo admin/superadmin → 403 si no).
     * Carril regular o insurance según lanePath.
     */
    enrollmentsByOma: (params = {}) =>
      apiGet(`${lanePath}/enrollments-by-oma`, params).then(unwrapData),
  }
}

const wlReportsApi = createReportsApi('weightloss/reports')
export const wlReportsInsuranceApi = createReportsApi('insurance/weightloss/reports')

export default wlReportsApi
